const FuzzyReaction = require('../bootstrap').FuzzyReaction;
const AppDispatcher = FuzzyReaction.Dispatcher;
const assign = require('object-assign');
const ModelStore = FuzzyReaction.Stores.ModelStore;
const AppActionConstants = require("../constants/AppActionConstants");
const ActionTypes = AppActionConstants.ActionTypes.messages;

/**
 * Data stores
 */
let _resourceData = {};
let _resourceListData = [];

/**
 * User store logic
 *
 * @type {*|exports}
 */
const EmailMessagesStore = assign({}, ModelStore, {
    getResource: function () {
        return _resourceData;
    },

    getResourceListData: function () {
        return _resourceListData;
    }
});

/**
 * Event Listeners
 */
EmailMessagesStore.dispatchToken = AppDispatcher.register(function (action) {
    switch (action.type) {
        case 'EMAIL-MESSAGES_RECEIVED':
        case 'EMAIL-MESSAGES_UPDATED':
        case 'EMAIL-MESSAGES_CREATED':
            _resourceData = action.data;

            EmailMessagesStore.emitChange();
            break;
        case 'EMAIL-MESSAGES_LISTED':
            _resourceListData = action.data;

            EmailMessagesStore.emitChange();
            break;
        case ActionTypes.CLEAR_STORED_MESSAGE:
            _resourceData = {};
            break;
    }
});

module.exports = EmailMessagesStore;
